export const IVR_CONFIGURATION_DIALOG_VISIBLE = 'IVR_CONFIGURATION_DIALOG_VISIBLE'
export const IVR_CONFIGURATION_CLEAR_FILTERS = 'IVR_CONFIGURATION_CLEAR_FILTERS'
export const SELECTED_IVR_CONFIGURATION_ID = 'SELECTED_IVR_CONFIGURATION_ID'
export const IVR_CONFIGURATION_FIELD = 'IVR_CONFIGURATION_FIELD'
export const SHOW_IVR_CONFIGURATION_LOADER = 'SHOW_IVR_CONFIGURATION_LOADER'
export const HIDE_IVR_CONFIGURATION_LOADER = 'HIDE_IVR_CONFIGURATION_LOADER'
export const INITIAL_IVR_CONFIGURATION_DATA = 'INITIAL_IVR_CONFIGURATION_DATA'
export const GET_IVR_CONFIGURATIONS = 'GET_IVR_CONFIGURATIONS'
export const GET_IVR_CONFIGURATION = 'GET_IVR_CONFIGURATION'
export const SET_IVR_CONFIGURATION_ERROR_FIELDS = 'SET_IVR_CONFIGURATION_ERROR_FIELDS';
export const GET_IVR_CONFIGURATION_PAGINATION = 'GET_IVR_CONFIGURATION_PAGINATION'
export const SET_IVR_CONFIGURATION_CURRENT_PAGE = 'SET_IVR_CONFIGURATION_CURRENT_PAGE'
export const SET_IVR_CONFIGURATION_CURRENT_SIZE = 'SET_IVR_CONFIGURATION_CURRENT_SIZE'
export const SHOW_IVR_CONFIGURATION_DETAIL_LOADING = 'SHOW_IVR_CONFIGURATION_DETAIL_LOADING'
export const SET_IVR_SCHEME_GRAPH_API_SLICE = 'SET_IVR_SCHEME_GRAPH_API_SLICE'

